export function formatUpdated(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const diffMs = now - d;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMs / 3600000);
  const diffDay = Math.floor(diffMs / 86400000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHr < 24) return `${diffHr}h ago`;
  if (diffDay < 7) return `${diffDay}d ago`;
  return d.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' }) +
    ' · ' + d.toLocaleTimeString('en-CA', { hour: 'numeric', minute: '2-digit' });
}

export function formatFullUpdated(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('en-CA', {
    weekday: 'short', month: 'short', day: 'numeric',
  }) + ' at ' + d.toLocaleTimeString('en-CA', { hour: 'numeric', minute: '2-digit' });
}
